import React, {useEffect , useState}from 'react';
import { MDBDropdown, MDBDropdownMenu, MDBDropdownToggle, MDBDropdownItem, MDBBtn } from 'mdb-react-ui-kit';
import ('./profileDropdown.css')
import Url from '../../../pages/url'

function ProfileDropdown() {
    const [ currentUserEmail, setCurrentUserEmail] = useState(false)
    const [ isAdmin, setIsAdmin ] = useState(false)
    const [ token, setToken ] = useState(false)
    const [tokenLoaded, setTokenLoaded] = useState(false)
    const [ notificationCount, setNotificationCount] = useState(0)

    useEffect(() => {
        if (localStorage.getItem("user")) {
            setCurrentUserEmail(localStorage.getItem("user"))
            localStorage.getItem("token")[3] == "Y" ?  setIsAdmin(true) : null
            setToken(localStorage.getItem("token").slice(0,3)+localStorage.getItem("token").slice(4))
            setTokenLoaded(true)
        }
    }, [])

    useEffect(() => {
        console.log(token)
        if (tokenLoaded & isAdmin) {
            fetch(Url+'project/navbar', {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "authorization": token
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        alert(data.error)
                    } 
                    setNotificationCount(data.count)
                    
                })
                .catch(err => console.log(err))
        }

    }, [tokenLoaded])


    function logout(){
        localStorage.clear()
        window.location.reload(false)
    }

    return (
        <>
        <a className="text-reset me-3" href="/">
            <span><i className="fas fa-home fa-md"></i></span>
        </a>
        {isAdmin ? notificationCount > 0 ? 
                <a
                type="button"
                className=" text-reset me-3 hidden-arrow large"
                href="/notification"
                aria-expanded="false"
                >
                <i className="fas fa-bell"></i>
                <span className="badge rounded-pill badge-notification bg-danger small">{notificationCount}</span>
                </a>
                : null : null }
        <MDBDropdown>
            {
                currentUserEmail 
                    ? <MDBDropdownToggle className='hidden-arrow'>
                        {currentUserEmail}
                        
                            </MDBDropdownToggle> 
                    : <MDBBtn href='/home'> Sign In</MDBBtn>
            }
            <MDBDropdownMenu>
                <MDBDropdownItem href='/' link>Home</MDBDropdownItem>
                <MDBDropdownItem href='/userProfile/myProfile' link>Profile</MDBDropdownItem>
                <MDBDropdownItem href='/createProject' link>Create Project</MDBDropdownItem>
                <MDBDropdownItem href='/myProjects' link>My Projects</MDBDropdownItem>
                
                { isAdmin 
                    ? <>
                        <hr class="hr" />
                        <MDBDropdownItem href='/notification' link>
                            Notifications {notificationCount > 0 ? <small><strong className='not'>{notificationCount}</strong></small> : null}
                        </MDBDropdownItem>
                        </>
                    : <MDBDropdownItem></MDBDropdownItem> 
                }

                { isAdmin 
                    ? <MDBDropdownItem href='/viewAllProjects' link>Manage All Projects</MDBDropdownItem> 
                    : <MDBDropdownItem></MDBDropdownItem> 
                }

                { isAdmin 
                    ? <MDBDropdownItem href='/viewAllUsers' link>Manage All Users</MDBDropdownItem>
                    : <MDBDropdownItem></MDBDropdownItem>
                }
                

                <MDBDropdownItem onClick={logout} href='/' link>Logout</MDBDropdownItem>
            </MDBDropdownMenu>
        </MDBDropdown>
        </>
    );
}

export default ProfileDropdown